import Meta from "../components/Meta";
import useDevice from "../hooks/useDevice";
import ProductScreenPC from "./PC/ProductScreen";
import ProductScreenSP from "./SP/ProductScreen";

const ProductScreen = () => {
    const isMobile = useDevice();
    
    return (<>
        <Meta
            title='検索 | ふるぷら'
            description='商品の詳細ページです。'
            keywords={['検索', 'ふるぷら', '古着', '下北', '古着屋', '高円寺']}
            robots='index, follow'
        />
        {isMobile ? <ProductScreenSP /> : <ProductScreenPC />}
    </>);
}

export default ProductScreen;